import ScrollReveal from "scrollreveal";

jQuery(document).ready(function($) {

function cleanSearchWebinars(){
    if ($('#webinar-category').val().length > 0) {
      let category = $('#webinar-category').find('option:selected').text();
      filterWebinars(null, category); 
    } else {
      $('.past-webinars .multiple-cards .webinar').show();
      $('.past-webinars .webinar .list li').removeClass('highlight');
      $('.no-results').hide();
      $('.results-found').hide();
      $('.past-webinars .webinar').removeClass('searchStyle');
    }
  }

function filterWebinars(value, category) {
    var counter = 0;
    
    // if search a value ( category optional)
     if (value) {
      var titleCard, band_content, band_category, category_name;
      value = value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

      $(".past-webinars .multiple-cards .webinar").each(function() {
        //filter by category
          band_category = true;
          if (category) {
            if ($(this).find('.category').text().toLowerCase() != category.toLowerCase()) {
              band_category = false;
            }
          }
          //search in title
          band_content = false;
          titleCard = $(this).find('.flip-card-front .title').text().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          category_name = $(this).find('.category').text().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

          if (titleCard.search(value) > -1 && band_category ) {
              $(this).addClass('searchStyle');
              $(this).show();
              band_content = true;
              counter ++;
          } else if (category_name.search(value) > -1 && band_category ) {
            $(this).addClass('searchStyle');
            $(this).show();
            band_content = true;
            counter ++;
          }
          //search in content
          var content,
          that = $(this);
          $(this).find('.flip-card-back .list li').each(function(){
            content = $(this).text().toLowerCase();
            content = content.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            if (content.search(value) > -1 && band_category) {
              $(that).addClass('searchStyle');
              $(that).show();
              $(this).addClass('highlight');
              if (!band_content) {
                counter ++;
              }
              band_content = true;
            } else if (!band_content) {
              $(that).hide();
            }
          });
           
      });
      // if search only a category
    }else if (category) {
      $(".past-webinars .multiple-cards .webinar").each(function() {
        if ($(this).find('.category').text().toLowerCase() == category.toLowerCase()) {
          $(this).addClass('searchStyle');
          $(this).show();
          counter ++;
        } else {
          $(this).hide();
        }
       
      });
    }
    // hide/show no results message
    if (counter == 0) {
      $('.no-results').show();
      $('.results-found').hide();
    } else {

      $('.no-results').hide();
      $('.results-found .count').text(counter);
      $('.results-found').show();
      /* var slideUpOne = {
        distance: "30px",
        origin: "bottom",
        //opacity: null,
        delay: 300,
        duration: 600,
        easing: "ease-in-out",
        scale: 0.9,
        opacity: 1,
        viewFactor: 0.5
      }; */
      //ScrollReveal().destroy();
      //ScrollReveal().reveal(".past-webinars .webinar", slideUpOne);
    }
}

  $('#webinar-category').on('change', function(){
    var search_value = $('#webinars-search').val(),
    category = $('#webinar-category').val().length > 0 ? $('#webinar-category').find('option:selected').text() : null;
    // if there is a search value, filter by value and category
    if (search_value.length > 3) {
        
      filterWebinars(search_value, category);
    } 
    else if ($(this).val().length > 0) {
      filterWebinars(null, category);
    } else {
      cleanSearchWebinars();
    } 
  });

  //Allow Enter just letters and spaces
  $('#webinars-search').keypress(function(event){
    var regex = new RegExp("^[A-zÀ-ú 0-9-_%:#]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
        event.preventDefault();
        return false;
    }
  });

  $('#webinars-search').keyup(function () {
    var category = $('#webinar-category').val().length > 0 ? $('#webinar-category').find('option:selected').text() : null;
    // Do nothing when lenght in shorter than 4, only maintain category search if it is selected in dropdown.
    if( $(this).val().length < 4 ) {
      if ($('#webinar-category').val().length == 0) {
        cleanSearchWebinars();
        $('.search-field').find('.academy-icon').removeClass('i-close').addClass('icon-search');    
    } else {
      filterWebinars(null, category);
    }

    return false;
  }
    $('.search-field').find('.academy-icon').removeClass('icon-search').addClass('i-close');
    var searchValue = $(this).val().toLowerCase();
    filterWebinars(searchValue, category);
  });

  $('.search-field .academy-icon').on('click', function(){
    if ($(this).hasClass('i-close')) {
      cleanSearchWebinars();
      $('#webinars-search').val('');
      $(this).removeClass('i-close').addClass('icon-search');
    }
});

});


(function($){
$(window).on('load', function() {
    //if searchBox exists, enable element after load the entire DOM.
    if ($('#webinars-pasados').length > 0 ) {
      $('.search-box').find('select').attr('disabled', false);
      $('#webinars-search').attr('disabled', false);
      $('#webinars-pasados').find('.multiple-cards').removeClass('disabled');
      $('.webinar-loader').fadeOut();
    }
});
})(jQuery);